import React, { useRef } from 'react'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { useAuthStore } from '../store'

const PayPalSubCheckout = ({ amount, onApprove }) => {
  const clickedRef = useRef(false); // 👈 여기!!
  let planId = "";
  if(amount == "19.99") {
    planId = "P-5C8949791W1246225NEYU5PQ";
  } else if(amount == "199.00"){
    planId = "P-6WN877241N831935YNEYU2XA";
  } else {
    alert("error invalid")
    return;
  }
  return (
      <PayPalScriptProvider
        options={{
          "client-id": 'AcvKC3LLYbQC7au57OW16O-HpRqynSHpJkcrox6rUTWxEPdgqB--mJse2dOkDw9uYu11zDPmRKGXnEpL',
          vault: true,              // 🔥 정기결제 필수 옵션
          currency: 'USD',
          intent: "subscription",   // 🔥 Orders API와 차이 핵심
          locale: "en_US",
          components: "buttons",
        }}
      >
        <PayPalButtons
         style={{
           layout: 'vertical',
           shape: 'rect',
           label: 'pay',
         }}
          createSubscription={(data, actions) => {
              if (clickedRef.current) {
                console.log("중복 클릭 방지됨");
                return;
              }
              clickedRef.current = true;
            return actions.subscription.create({
              plan_id: planId        // "P-XXXX" 형식 ID
            });
          }}
          onApprove={(data) => {
            //console.log("Subscription ID:", data.subscriptionID);
            if (typeof onApprove === "function") {
              onApprove({
                subscriptionID: data.subscriptionID
              });
            }
          }}
          onError={(err) => {
            console.error("[PAYPAL] subscription error:", err);
            clickedRef.current = false; // 에러시 다시 허용!
          }}
        />
      </PayPalScriptProvider>
    );
}

export default PayPalSubCheckout
